export default __webpack_public_path__ + "static/media/ithiri4.0495c89f.png";